export default{
    data () {
        return {
            defNum:0,
            stic:0,
            rotateBarList:[],
            rotaBar:[],
            initList:[],
            deftext:0,
            forList:[],
            definitList: [],
            defRotateBarList:[],
            RdefNum:0,
            curTime:null,
            schimin:0,
            barmax:0
        }
    },
    created () {
        const self = this
    
        for(let f=0;f<50;f++){
          self.rotaBar.push(f)
        }
    },
    watch: {
        emitpielist:{
            handler:function(newV){
                const self = this
                if(newV != undefined){
                    self.pieList = newV
                    setTimeout(()=>{
                        self.setPie()
                    },0)
                }
            },
            deep:true,
            immediate: true
        },
        static:{
            handler:function(newV,oldV){
                const self = this
                self.stic = newV
                if(self.stic == 3){
                    self.defNum = 0
                    self.RdefNum = 0
                    self.rotateBarList = []
                    self.rotaBar = []
                    self.initList = []
                }

                if(self.stic == 4 || self.stic == 5){
                    return false
                }

                if(self.definitList.length > 0){
                    self.getSeep()
                    self.setRbar()
                }
            },
            deep:true,
            immediate: true
        },

        rotateBar:{
            handler:function(newV,oldV){
                const self = this
                if(newV != undefined){
                    this.$store.state.BarList = newV
                    self.defRotateBarList = this.$store.state.BarList
                }
            },
            immediate: true,
            deep:true,
        },

        Bars:{
            handler:function(newV,oldV){
                const self = this
                if(newV != undefined){
                    self.definitList = newV
                }
            },
            immediate: true,
            deep:true,
      
          },
        curtime:{
            handler:function(newV,oldV){
                const self = this
                if(newV != undefined || newV != null){
                    this.$store.state.curTime = newV

                    let initnum = parseInt((newV * 1000) / 40)
                    let Barnum = parseInt((newV * 1000) / 200)
                    self.initList = []
                    self.rotateBarList = []
                    setTimeout(()=>{
                        for(let i=0;i<initnum;i++){
                            self.initList.push(self.definitList[i])
                        }
                        self.rotateBarList = this.$store.state.BarList[Barnum]          
                        if(self.barmax != undefined || self.barmax != null){
                            if(typeof(self.rotateBarList) != 'number'){
                                if(self.barmax < Math.max(...self.rotateBarList)){
                                    self.barmax = Math.max(...self.rotateBarList)
                                }    
                            }else{
                                if(self.barmax < self.rotateBarList){
                                    self.barmax = self.rotateBarList
                                }    
                            }
                            
                        }
                        self.dwe()
                        self.Rbardwe()
                        if(self.stic == 6){
                            self.stic = 5
                        }
                        self.getSeep()
                        self.setRbar()
                        if(self.stic == 5){
                            setTimeout(()=>{
                                self.stic = 6
                                self.getSeep()
                                self.setRbar()
                            },30)
                        }
                    },0)

                    self.defNum = parseInt((newV * 1000) / 40)
                    self.RdefNum = parseInt((newV * 1000) / 200)
                }
            },
            immediate: true,
            deep:true,
      

        },
       
    },
    methods: {
        async getSeep(){
            const self = this
            let initlistleng = self.definitList.length
            for(let i=self.defNum;i<initlistleng;i++){
                if(self.stic === 0){
                    self.defNum = i
                    break;
                }else if(self.stic == 3 || self.stic == 4 || self.stic == 5){
                    break;
                }else{
                    await self.seep(27)
                }
                
                if(Math.sign(self.definitList[i]) == -1){
                    self.definitList[i] = 40
                }
                self.initList.push(self.definitList[i])
            }
        },
        async setRbar(){
            const self = this
            let barLeng = this.$store.state.BarList.length
            
            for(let i=self.RdefNum;i<barLeng;i++){
                
                if(self.stic === 0){
                    self.RdefNum = i
                    break;
                }else if(self.stic == 3 || self.stic == 4 || self.stic == 5){
                    break;
                }else{
                    await self.setSleep(200)
                }
                self.rotateBarList = this.$store.state.BarList[i]

                let max;
                if(typeof(self.rotateBarList) != 'number'){
                    max = Math.max(...self.rotateBarList)
                }else{
                    max = self.rotateBarList
                }
                
                let maxNetx;
                if(i > 0){
                    if(this.$store.state.BarList[i - 1] != undefined){
                        if(typeof(this.$store.state.BarList[i - 1]) != 'number'){
                            maxNetx = Math.max(...this.$store.state.BarList[i - 1])    
                        }else{
                            maxNetx = this.$store.state.BarList[i - 1]
                        }
                    }
                    
                }

                if(i <= 0){
                    if(typeof(self.rotateBarList) != 'number'){
                        self.barmax = Math.max(...self.rotateBarList)
                    }else{
                        self.barmax = self.rotateBarList
                    }
                    
                }else{
                    let max,maxNetx;
                    if(typeof(self.rotateBarList) != 'number'){
                        max = Math.max(...self.rotateBarList)
                    }else{
                        max = self.rotateBarList
                    }

                    if(this.$store.state.BarList[i - 1] != undefined){
                        if(typeof(this.$store.state.BarList[i - 1]) != 'number'){
                            maxNetx = Math.max(...this.$store.state.BarList[i - 1])    
                        }else{
                            maxNetx = this.$store.state.BarList[i - 1]
                        }
                    }
                    
                    if(max > maxNetx){
                        if(max > self.barmax){
                            self.barmax = max
                        }else{
                            self.barmax = self.barmax
                        }
                    }else{
                        // self.barmax = maxNetx
                    }
                }
                

                // console.log('Math.min(..this.$store.state.BarList[i])===',Math.max(...self.rotateBarList));    
            }
        },
        setSleep(num){
            const self = this
            return new Promise((resolve,reject)=>{
                setTimeout(()=>{
                    self.Rbardwe()
                    resolve(1)
                },num)
            })
        },
        seep(num){
            const self = this
            return new Promise((resolve,reject)=>{
                setTimeout(()=>{
                    self.dwe()
                    resolve(1)
                },num)
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/MyChart/minix.js